import { Injectable } from '@angular/core';
import { AppConfigService } from './app-config.service';



@Injectable()
export class FeatureFlagService {
  constructor( private appConfigService: AppConfigService ) {}
  featureOff( featureName: string ) {
    // Read the value from the config service
    const features = this.appConfigService.getConfig().features;
    if ( features && features.hasOwnProperty( featureName ) ) {
      return features[featureName] === 'false';
    }
    return true; // if feature not found, default to turned off
  }

  featureOn( featureName: string ) {
    return !this.featureOff( featureName );
  }
}
